import { faCrab, faFish, faSquid } from '@fortawesome/pro-solid-svg-icons';

import theme from '@style/theme.json';

const SPECIES_GROUPS = {
  molluscs: {
    color: '#44B0E1',
    icon: faSquid,
    label: 'Molluscs',
  },
  crustaceans: {
    color: theme.color.warning,
    icon: faCrab,
    label: 'Crustaceans',
  },
  fish: {
    color: theme.color.success,
    icon: faFish,
    label: 'Fish',
  },
};

export { SPECIES_GROUPS };
